module.exports = __webpack_public_path__ + "images/category_lp/common/store_images/brand_revalue_618212bc9ceec3b9d996674b31d6ad0f.png";